const jsContentHandler = {
  init() {
    if (!document.querySelector('#js-content')
      || !document.querySelector('.post-navigation')) {
      return;
    }

    // Respect data-append-anchors on .post-navigation to control URL hash updates
    this.shouldAppendAnchors = document.querySelector('.post-navigation')?.dataset.appendAnchors === 'true';

    this.setupSidebarAndContentNavigation();

    // Initial URL hash check and update
    this.hashChangeHandler();

    // Listen for hash changes and handle navigation
    window.addEventListener('hashchange', () => this.hashChangeHandler());

    // Track scrolling to update active state in navigation and URL
    this.setupScrollingTracking();

    // Toggle sticky content for mobile and tablet.
    this.toggleStickyContent();

    // Set top value for sidebar.
    this.updateLeftBarTop();

    window.addEventListener('resize', () => {
      this.updateLeftBarTop();
    });
  },

  hashChangeHandler() {
    const urlHash = this.getActiveNavItemFromHash();
    if (urlHash) {
      this.activateNavItemsById(urlHash);
    }
  },

  activateNavItemsById(itemId) {
    const item = document.querySelector(`#${CSS.escape(itemId)}`);
    const navItem = document.querySelector(`.post-navigation li a[href="#${CSS.escape(itemId)}"]`);

    const header = document.querySelector('header');

    if (item && navItem) {
      // Uncomment if header hide in scrolling down.
      const headerOffset = /* item.getBoundingClientRect().top < 0 && */ header
        ? header.offsetHeight
        : 40;

      const scrollToPosition = innerWidth > 1180
        ? item.getBoundingClientRect().top + window.scrollY - headerOffset
        : item.getBoundingClientRect().top + window.scrollY - window.innerHeight / 2;

      window.scrollTo({ top: scrollToPosition, behavior: 'smooth' });

      // Clear active class from all items
      document.querySelectorAll('.post-navigation li').forEach(li => li.classList.remove('active'));
      document.querySelectorAll('#js-content h2, #js-content h3').forEach(h => h.classList.remove('active'));

      // Set active class on the target item and navigation link
      item.classList.add('active');
      navItem.parentElement.classList.add('active');

      // Update URL without causing a new scroll
      if (this.shouldAppendAnchors) {
        history.replaceState(null, null, `#${itemId}`);
      }

      // Show <h3> elements under the current <h2>
      if (item.classList.contains('h3-link')) {
        return;
      }
      this.showSubHeadings();
    }
  },

  getActiveNavItemFromHash() {
    return window.location.hash.substring(1);
  },

  setupSidebarAndContentNavigation() {
    // Attach click event listener to sidebar items
    document.querySelectorAll('.post-navigation li a').forEach(link => {
      link.addEventListener('click', event => {
        event.preventDefault();
        /* Disable scroll observing when scroll by click  */
        document.querySelector('.post-navigation').classList.add('scrolling');
        /* Force hide sub-nav-items while scrolling page by click */
        let hideSubItems = false;
        const isSubItem = link.parentElement.classList.contains('h3-link');

        const targetId = link.getAttribute('href').substring(1);

        const heading = document.getElementById(targetId);
        const isInViewport = isElementTopAndBottomVisible(heading);

        /* If it is already active */
        if (link.parentElement.classList.contains('active') && isInViewport) {
          this.collapseStickyContent();
          return;
        }

        if (!isSubItem) {
          const currentActiveNavIsSubItem = document.querySelector(
            '.post-navigation li.h3-link.active',
          );
          if (currentActiveNavIsSubItem) {
            const parentOfActiveNavItem = this.getPrevious(
              currentActiveNavIsSubItem,
              'li:not(.h3-link)',
            );
            hideSubItems = !link.parentElement.isEqualNode(parentOfActiveNavItem);
          } else {
            hideSubItems = true;
          }
        }
        if (hideSubItems) {
          document.querySelector('.post-navigation').classList.add('hide-subitems');
        }

        this.activateNavItemsById(targetId);

        setTimeout(
          () => {
            /* Enable scroll observing  */
            document.querySelector('.post-navigation').classList.remove(
              'scrolling',
              'hide-subitems',
            );
            this.collapseStickyContent();
          },
          700,
        );
      });
    });
  },

  setupScrollingTracking() {
    window.addEventListener('scroll', () => this.trackUserScrollingByHeading());
  },

  trackUserScrollingByHeading() {
    if (document.querySelector('.post-navigation.scrolling')) {
      return;
    }
    const winScrollTop = window.pageYOffset;
    const windowHeight = window.innerHeight;
    const headingSelectors = Array.from(document.querySelectorAll('#js-content h2'));
    let activeIndex = -1;
    let lastActiveH2Index = -1;

    headingSelectors.forEach((heading, i) => {
      const headingTop = heading.getBoundingClientRect().top + window.pageYOffset;
      const headingInViewport = innerWidth > 1180
        ? headingTop - winScrollTop <= windowHeight * 0.2
        : headingTop - winScrollTop <= windowHeight * 0.5;

      if (headingInViewport) {
        activeIndex = i;
        if (heading.tagName.toLowerCase() === 'h2') {
          lastActiveH2Index = i;
        }
      }
    });

    const navItems = document.querySelectorAll('.post-navigation li');

    // Remove active class from all elements
    headingSelectors.forEach(h => h.classList.remove('active'));
    navItems.forEach(navItem => navItem.classList.remove('active'));

    // Set active class on the currently active item and update URL
    if (activeIndex !== -1 && activeIndex < headingSelectors.length) {
      const activeHeading = headingSelectors[activeIndex];
      activeHeading.classList.add('active');
      navItems[activeIndex]?.classList.add('active');

      // Update the URL hash without causing a page jump
      const activeId = activeHeading.getAttribute('id');
      if (this.shouldAppendAnchors && activeId && window.location.hash !== `#${activeId}`) {
        history.replaceState(null, null, `#${activeId}`);
      }

      // Show <h3> elements under the last active <h2>
      if (lastActiveH2Index !== -1) {
        this.showSubHeadings();
      }
    }
  },

  showSubHeadings() {
    const activeNavItem = document.querySelector('.post-navigation li.active');
    const isH3 = activeNavItem.classList.contains('h3-link');
    const parentH2 = isH3
      ? this.getPrevious(activeNavItem, 'li:not(.h3-link)')
      : activeNavItem;

    if (!isH3 || activeNavItem.matches('.hidden')) {
      const subitems = this.getNextUntil(parentH2, 'li:not(.h3-link)');
      // Show all .h3-link under the active h2
      document.querySelectorAll('.post-navigation li.h3-link').forEach(li => {
        if (subitems.includes(li)) {
          li.classList.remove('hidden');
        } else {
          li.classList.add('hidden');
        }
      });
    }
  },

  getPrevious(element, selector) {
    let previous = element.previousElementSibling;
    while (previous) {
      if (previous.matches(selector)) {
        return previous;
      }
      previous = previous.previousElementSibling;
    }
    return null;
  },

  getNextUntil(elem, selector) {
    const subitems = [];
    let next = elem?.nextElementSibling;

    while (next) {
      if (next.matches(selector)) {
        break;
      }
      subitems.push(next);
      next = next.nextElementSibling;
    }

    return subitems;
  },

  toggleStickyContent() {
    document.querySelector('.js-toggle-sticky-content')?.addEventListener('click', e => {
      e.currentTarget.parentElement.classList.toggle('active');
    });
  },

  collapseStickyContent() {
    document.querySelector('.content-sticky')?.classList.remove('active');
  },

  updateLeftBarTop() {
    const leftBar = document.querySelector('.left-bar');
    const sticky = document.querySelector('.left-bar .content-sticky');
    const content = sticky?.querySelector('.content-sticky__content');
    const header = document.querySelector('.js-header');
    const adminBar = document.querySelector('#wpadminbar');

    if (!leftBar || !sticky || !header) return;

    if (window.innerWidth <= 1024) {
      const headerHeight = header.offsetHeight;
      const adminBarHeight = adminBar && window.innerWidth >= 600 ? adminBar.offsetHeight : 0;

      sticky.style.top = `${headerHeight + adminBarHeight}px`;

      if (content) {
        const toggleHeight = sticky.querySelector('.content-sticky__toggle')?.offsetHeight || 0;

        // Bound the dropdown to the remaining viewport space so it scrolls internally
        // instead of overflowing past the bottom of the screen where it can't be reached.
        content.style.maxHeight = `calc(100dvh - ${headerHeight + adminBarHeight + toggleHeight}px)`;
      }
    } else {
      sticky.style.top = '';
      sticky.style.paddingTop = '';

      if (content) {
        content.style.maxHeight = '';
      }
    }
  },
};

function isElementTopAndBottomVisible(element) {
  const rect = element.getBoundingClientRect();
  const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

  // Check if the top edge is visible
  const isTopVisible = rect.top >= document.querySelector('header').clientHeight && rect.top <= viewportHeight;

  // Check if the bottom edge is visible
  const isBottomVisible = rect.bottom >= 0 && rect.bottom <= viewportHeight;

  return isTopVisible && isBottomVisible;
}

const jsShareHandler = {
  /**
   * Share Link
   */
  shareLink() {
    const copyLinkElements = document.querySelectorAll('.js-copy-button');

    if (copyLinkElements) {
      copyLinkElements.forEach(element => {
        const associatedResult = element.querySelector('.js-copy-result');

        element.addEventListener('click', e => {
          e.preventDefault();
          this.copyCurrentUrl();
          if (associatedResult) {
            this.fadeResult(associatedResult);
          }
        });
      });
    }
  },

  /**
   * Copies the current URL to the clipboard
   */
  copyCurrentUrl() {
    const currentURL = window.location.href;
    const tempInput = document.createElement('input');
    tempInput.value = currentURL;
    document.body.appendChild(tempInput);
    tempInput.select();
    tempInput.setSelectionRange(0, 99999);
    document.execCommand('copy');
    document.body.removeChild(tempInput);
  },

  /**
   * Fades the result element
   * @param {Element} resultElement - The result HTML element
   */
  fadeResult(resultElement) {
    const FADE_DELAY = 1000;

    setTimeout(() => this.fadeElement(resultElement), FADE_DELAY);
  },

  /**
   * Fades an HTML element
   * @param {Element} element - The HTML element to fade
   */
  fadeElement(element) {
    const FADE_DURATION = 3;

    if (element) {
      element.style.transition = `opacity ${FADE_DURATION}s`;
      element.style.opacity = '1';
      element.addEventListener('transitionend', () => {
        element.style.opacity = '0';
      });
    }
  },
};

const jsBreadcrumbs = {
  breadcrumbsEllipsis() {
    document.querySelectorAll('.breadcrumbs')?.forEach(breadcrumbs => {
      breadcrumbs.addEventListener('click', () => {
        breadcrumbs.style.flexWrap = 'wrap';

        breadcrumbs.querySelectorAll('p').forEach(el => {
          el.style.whiteSpace = 'normal';
          el.style.textOverflow = 'unset';
          el.style.overflow = 'visible';
          el.style.width = 'auto';
        });
      });
    });
  },
};

const jsProgressBarHandler = {
  init() {
    this.updateProgressBarPosition();

    window.addEventListener('resize', () => {
      this.updateProgressBarPosition();
    });

    this.supportAnimationTimeline();
  },

  updateProgressBarPosition() {
    const progressBar = document.querySelector('.progress-bar');
    const header = document.querySelector('.js-header');
    const adminBar = document.querySelector('#wpadminbar');

    if (!progressBar || !header) return;

    const headerHeight = Math.round(header.getBoundingClientRect().height);
    const adminBarHeight = (adminBar && window.innerWidth >= 600) ? Math.round(adminBar.getBoundingClientRect().height) : 0; // eslint-disable-line max-len

    // Set sticky top
    progressBar.style.top = `${headerHeight + adminBarHeight}px`;
  },

  supportAnimationTimeline() {
    if (!CSS.supports('animation-timeline: scroll()')) {
      const progressBar = document.querySelector('.progress-bar');

      window.addEventListener('scroll', () => {
        const scrollTop = window.scrollY;
        const docHeight = document.body.scrollHeight - window.innerHeight;
        const scrollPercent = docHeight > 0 ? scrollTop / docHeight : 0;
        progressBar.style.transform = `scaleX(${scrollPercent})`;
      });

      // Fix for Safari.
      setTimeout(() => {
        window.dispatchEvent(new UIEvent('resize'));
      }, 100);
    }
  },
};

// Initialize on DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
  jsContentHandler.init();
  jsShareHandler.shareLink();
  jsBreadcrumbs.breadcrumbsEllipsis();
  jsProgressBarHandler.init();
});
